<template>
  <modal :id="itemStatusModalId">
    <div class="add-user">
      <b-row>
        <b-col>
          <close-button
            class="float-right"
            @close-button-click="handleCloseBtnClick"
          />
        </b-col>
      </b-row>
      <h3>
        Add A Memory
      </h3>
      <b-row>
        <b-col>
          <b-img
            v-if="formMemory && formMemory.imgURL"
            :src="formMemory.imgURL"
            fluid
            style="object-fit: contain"
            :alt="`My Memory with Derriana`"
          />
          <image-upload
            v-else
            ref="image-upload"
            class="photo-upload-wrapper"
            :img-upload-idx="idx"
            img-upload-type="photo"
            :storage-path="storagePath"
            :max-image="1"
            :show-edit="false"
            :show-delete="true"
            text-drag="Click to upload or drag photo memory (.png, .jpg) here. "
            @img-uploaded-url="handlePhotoUploadedURL"
          />
        </b-col>
        <b-col>
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Your Name"
              label-info=""
            />
            <b-form-input
              v-model="formMemory.name"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;
                    background-color:#dcabb0;
                    border-color: #b2ac88;"
              placeholder="Your Name"
            />
          </b-form-group>
          <b-form-group>
            <label-info
              v-if="false"
              id="form-comment"
              label-name="Comment"
              label-info=""
            />

            <b-form-textarea
              type="text"
              v-model="formMemory.comment"
              :maxlength="maxLen"
              :state="formMemory.comment && formMemory.comment.length >= minLen && formMemory.comment.length <= maxLen"
              style="
                    border-radius:15px;
                    padding:20px;
                    background-color:#dcabb0;
                    border-color: #b2ac88;
                    "
              rows="3"
              max-rows="6"
              placeholder="Derriana and I had the best time during this photo ..."
            />
          </b-form-group>
          <small>{{ formMemory.comment && formMemory.comment.length ? formMemory.comment.length : 0 }} / {{maxLen}}</small>
          <span class="error">
            <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
              {{ anError }}
            </div>
          </span>
          <b-form-group>
            <b-button
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #b2ac88; padding: 10px;"
              @click="handleAddMemoryClick"
            >
              Add Memory
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import ImageUpload from "@/components/common/imageUpload";
import axios from "axios";
export default {
  name: "Admin_Manage_Sessions_UpdateStatus",
  mixins: [UploadImage, VideoHandling],
  components: {
    Modal,
    CloseButton,
    ImageUpload
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    itemStatusModalId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    }
  },
  created() {
    this.formReset();
  },
  mounted() {},
  methods: {
    handleAddItem() {
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemStatusModalId);
    },
    handlePhotoUploadedURL(idx, url) {
      this.formMemory.imgURL = url;
    },
    handleAddMemoryClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/submitMemory", {
            form: this.formMemory,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
          });
      });
    },
    simpleValidate() {
      this.errors = [];

      /* if (this.formMemory && !this.validateEmail(this.formMemory.email))
         this.errors.push("Please enter a valid email");*/

      if (
        (this.formMemory && !this.formMemory.name) ||
        this.formMemory.name.length === 0
      )
        this.errors.push("Please enter your name");

      if (
        (this.formMemory && !this.formMemory.comment) ||
        this.formMemory.comment.length === 0
      )
        this.errors.push("Comment is required");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formMemory = null;
      this.formMemory = this.formDefault;
    },
    handleSubmitANewMemory() {
      this.formReset();
      this.memorySubmitted = false;
    }
  },
  data() {
    return {
      idx: 0,
      minLen: 5,
      maxLen: 55,
      storagePath: "derriana_memories_imgs",
      formMemory: null,
      formDefault: {
        name: null,
        comment: null,
        imgURL: null
      },
      errors: [],
      entity: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
